import { render, staticRenderFns } from "./MovieContainer.vue?vue&type=template&id=4fd19bf7&scoped=true&"
import script from "./MovieContainer.vue?vue&type=script&lang=ts&"
export * from "./MovieContainer.vue?vue&type=script&lang=ts&"
import style0 from "./MovieContainer.vue?vue&type=style&index=0&id=4fd19bf7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd19bf7",
  null
  
)

export default component.exports